module.exports = __webpack_public_path__ + "static/media/campaign.08a79de1.png";